
import { useState, useEffect } from "react";

const useDebounce = (value, delay = 500) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handle = setTimeout(() => setDebouncedValue(value), delay);
      return () => clearTimeout(handle);
    }, [value, delay]);
    return debouncedValue;
}   

export default useDebounce


